module.exports = __webpack_public_path__ + "static/media/10254.438b7cd6.jpg";